import Image from "next/image";
import Link from "next/link";
import React from "react";

interface MenuLogoProps {
    logoUrl: string;
    onLogoClick: () => void;
}

const MenuLogo: React.FC<MenuLogoProps> = ({ logoUrl, onLogoClick }) => {
    return (
        <Link href="/" className="relative z-50" onClick={onLogoClick}>
            <Image
                src={logoUrl}
                alt="logo.svg"
                width={120}
                height={40}
                quality={100}
                className="min-w-[120px] mr-auto ml-0"
                priority
                loading="eager"
            />
        </Link>
    );
};

export default MenuLogo;
